import { render, staticRenderFns } from "./GamificationDetails.vue?vue&type=template&id=51e70db2&scoped=true&"
import script from "./GamificationDetails.vue?vue&type=script&lang=js&"
export * from "./GamificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./GamificationDetails.vue?vue&type=style&index=0&id=51e70db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e70db2",
  null
  
)

export default component.exports